var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns is-vcentered"},[_c('div',{staticClass:"column is-narrow"},[_c('ToggleButton',{staticClass:"is-size-7",attrs:{"speed":250,"value":_vm.value,"labels":{
        checked: '',
        unchecked: ''
      },"width":_vm.toggleConfig.width,"height":_vm.toggleConfig.height,"color":_vm.toggleConfig.colors,"switch-color":_vm.toggleConfig.switchColour,"sync":true},on:{"change":_vm.toggle}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }